import payments from '@/api/payments';

const SET_PAYMENTS = 'SET_PAYMENTS';
const APPEND_PAYMENTS = 'APPEND_PAYMENTS';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const RESET_PAYMENTS = 'RESET_PAYMENTS';
const EDIT_PAYMENTS = 'EDIT_PAYMENTS';
const DELETE = 'DELETE';

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
	isFetched: false,
};

const getters = {
	all: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	isFetched: state => state.isFetched,
};

const mutations = {
	[SET_PAYMENTS](state, items) {
		state.all = items;
	},
	[APPEND_PAYMENTS](state, items) {
		state.all = state.all.concat(items);
	},
	[RESET_PAYMENTS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[DELETE](state, index) {
		state.all.splice(index, 1);
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[EDIT_PAYMENTS](state, { id, status }) {
		const index = state.all.findIndex(payment => payment._id === id);
		if (index !== -1) {
			state.all[index].status = status;
		}
	},
};

const actions = {
	getList({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const payments = response.data;
				if (payments.length !== 0) {
					commit(APPEND_PAYMENTS, payments);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHED, true);
			};
			payments.getList(params, callback, errorCallback);
		}
	},
	reset({ commit }) {
		commit(RESET_PAYMENTS);
	},
	delete({ commit }, index) {
		commit(DELETE, index);
	},
	edit({ commit }, payload) {
		commit(EDIT_PAYMENTS, payload);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
